jQuery(function ($) {
  const $winW = $(window).width();
  const $bp = 1080;
  // フッター非表示
  $('#shopify-section-footer').remove();

  $(window).on('load', function () {  // サイドバー

    // 重複削除
    $('.cat-item-hokkaido-tohoku').nextAll('.cat-item-hokkaido-tohoku').remove();
    $('.cat-item-kanto').nextAll('.cat-item-kanto').remove();
    $('.cat-item-chubu').nextAll('.cat-item-chubu').remove();
    $('.cat-item-kinki').nextAll('.cat-item-kinki').remove();
    $('.cat-item-chugoku').nextAll('.cat-item-chugoku').remove();
    $('.cat-item-shikoku').nextAll('.cat-item-shikoku').remove();
    $('.cat-item-kyusyu').nextAll('.cat-item-kyusyu').remove();


  });
  $(window).on('load', function () {
    $('.cat-item:first-of-type').addClass('-active');
    let $btn = $('.cat-item a');
    $btn.on('click', function () {
      $(this).parent().siblings().removeClass('-active');
      $(this).parent().addClass('-active');
    });
  });
  $(window).on('load', function () {  //記事がない場合
    $('.js-noPost-lg').each(function () {
      if (!$(this).find('.m-article').length) {
        $(this).remove();
      }
    });
    $('.js-noPost-sm').each(function () {
      if (!$(this).find('.m-item').length) {
        $(this).remove();
      }
    });
  });


  $(function () {  // SP追従
    if ($winW <= $bp) {
      $(window).on('scroll', function () {
        let $scroll = $(window).scrollTop(),
          $winH = $(window).height();

        const $select_area = $('.Select').offset().top;
        const $ft_area = $('.ftInfo').offset().top;

        if ($scroll > $select_area - $winH + 80) {
          $('.Follow').removeClass('is-show');
          $('.Follow.is-select').addClass('is-show');
        } else {
          $('.Follow').removeClass('is-show');
          $('.Follow.is-store').addClass('is-show');
        }

        if ($scroll > $ft_area - $winH) {
          $('.Follow').removeClass('is-show');
        }

      });
    }
  });


  $(function () {  // 詳細PCレイアウト調整
    if ($winW > $bp) {
      const $layoutFix_winH = $(window).height();
      const $layoutFix_elOst = $('.js-layoutFix').position().top;
      const $layoutFix_elH = $('.Post .head').height();
      const $layoutFix_gap = Math.floor($layoutFix_winH - $layoutFix_elOst - $layoutFix_elH);

      $(window).on('scroll', function () {
        let $scroll = $(window).scrollTop(),
          $winH = $(window).height();

        const $layoutFix_targetOst = $('.js-layoutFix-target').offset().top;
        if ($scroll > $layoutFix_targetOst - $winH + $layoutFix_gap + 118) {
          $('.js-layoutFix').removeClass('is-fixed');
        } else {
          $('.js-layoutFix').addClass('is-fixed');
        }

      });
    }
  });

  $(function () {  // 体験メニュー
    $('.detailMenu li').find('strong').parent().css('opacity', 1);

    // 色別
    const $items = $('.js-colorFilter li');
    $items.each(function () {
      if ($(this).find('strong').length) {
        var $str = $(this).find('strong').text();
        var $text = $str.substr($str.indexOf('--') + 2);
        colorFilter($str, $(this));
        $(this).append('<strong>').text($text);
      } else {
        var $str = $(this).text();
        var $text = $str.substr($str.indexOf('--') + 2);
        colorFilter();
        $(this).text($text);
      }

      function colorFilter(str, item) {
        if (str.indexOf('Anker') !== -1) {
          item.addClass('-anker');
        } else if (str.indexOf('Soundcore') !== -1) {
          item.addClass('-soundcore');
        } else if (str.indexOf('Eufy') !== -1) {
          item.addClass('-eufy');
        } else if (str.indexOf('Nebula') !== -1) {
          item.addClass('-nebula');
        }
      }

    });
  });

  $(window).on('load', function () {  // 関連記事の調整
    const url = location.href;
    const $targets = $('.Other .m-article');
    const host = location.hostname;
    $targets.each(function () {
      let $targetHref = $(this).find('.m-btn').attr('href');
      let $targetUrl = 'https://' + host + $targetHref;
      if ($targetUrl === url) {
        $(this).remove();
      }
    });

  });
});
